export enum CommentEventType {
  PICKUP = 'PICKUP',
  TRANSFER_TO_ANOTHER_CARRIER = 'TRANSFER_TO_ANOTHER_CARRIER',
  DELIVER_AT_MIDDLE_LOCATION = 'DELIVER_AT_MIDDLE_LOCATION',
  PICKUP_AT_MIDDLE_LOCATION = 'PICKUP_AT_MIDDLE_LOCATION',
  DELIVERY = 'DELIVERY',
  VERIFICATION_AFTER_DELIVERY = 'VERIFICATION_AFTER_DELIVERY',
}
